import { useEffect } from 'react';

import { bootstrapSession, useSessionStore } from '@/entities/session';
import type { SessionStatus } from '@/entities/session';

/**
 * Вход выполняется один раз при старте приложения.
 *
 * StrictMode в dev монтирует эффекты дважды — повтор гасится single-flight
 * внутри `authenticate()`, а не флагом в компоненте.
 */
export function useSessionBootstrap(): {
  status: SessionStatus;
  error: string | null;
  retry: () => void;
} {
  const status = useSessionStore((state) => state.status);
  const error = useSessionStore((state) => state.error);

  useEffect(() => {
    void bootstrapSession();
  }, []);

  return {
    status,
    error,
    retry: () => {
      void bootstrapSession();
    },
  };
}
